import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';

function AboutPage(props) {
  return (
  	<Fragment>
      <Helmet>
        <title>About</title>
      </Helmet>
      <div className="about-detail row">
        <div className="text about-detail__text">
          <h1>
            About the RTA MedSafety tracer tool and Joint Commission Resources
          </h1>
          <h2 className="small-h2">
            Introduction and Instructions
          </h2>
          <p>
            Errors associated with injectable medications are more likely to result in death and morbidity than medications given through other routes. Risk of error is present with medication preparation and manipulation as well as administration. It is for that reason that The Joint Commission's Medication Management standards direct that medications be dispensed in the most ready-to-administer (RTA) form as possible. Even with that goal in mind, the reality is that there are often barriers. This tool has been designed to identify those barriers in order to tailor performance improvement efforts and achieve the goal of dispensing medications in the most ready-to-administer form possible.
          </p>
          <h2 className="small-h2">
            The Role of the Tracer
          </h2>
          <p>
            Tracer methodology, created by The Joint Commission, assesses the processes, communication, and coordination of the delivery of care in health care organizations. Tracer methodology is a powerful tool that uses observations, document review, and interviews to understand the current state of practices and identify opportunities for improvement.
          </p>
          <p>
            This tracer tool assesses how injectable medications are provided at various points of care and decision-making and identifies the factors that lead to either successful provision of medications in a ready-to-administer form or that prevent such administration. This tracer tool is designed to help hospitals in assessing the challenges and barriers and prioritizing and developing corrective action plans to improve the safety of injectable medications.
          </p>
          <p>
            The tool is composed of tracer modules that can be completed individually or together and can be customized:
          </p>
          <ol>
            <li>
              Patient Safety and Regulatory Compliance Tracer: Addresses leadership philosophy, understanding of regulatory requirements, and  direction for how the pharmacy provides injectable medications
            </li>
            <li>
              Pharmacy Tracers: Address medication purchasing, medication order configuration in computerized provider order entry (CPOE) systems, medication storage, medication order verification, and medication dispensing practices
            </li>
            <li>
              Nursing Unit Tracer: Addresses nurses’ processes, challenges, and barriers regarding injectable medications
            </li>
            <li>
              Anesthesia Tracer: Addresses anesthesia providers’ processes, challenges, and barriers regarding injectable medications
            </li>
          </ol>
          <h2 className="small-h2">
            Who Should Participate
          </h2>
          <ul>
            <li>
              The person(s) performing the tracers should be nonbiased, objective, and supportive to obtain honest feedback from staff. Because of the pharmacist’s influence in decisions relating to dispensing of injectable medications, pharmacy leadership should lead and actively participate in each tracer activity.  Different clinicians and professionals may have unique perspectives with injectable medications, so nursing leadership, accreditation professionals, quality management/performance improvement professionals, safety officers, and others should also participate in the tracer activity.
            </li>
            <li>
              A scribe may be valuable in documenting tracer observations and responses that can then be analyzed to identify opportunities for improvement. 
            </li>
            <li>
              To fully understand variance among practitioners, observe and interview several pharmacy staff, nurses, and anesthesia providers during the tracer activity. The tracer tool allows for one-on-one conversations as well as group discussions.
            </li>
          </ul>
          <h2 className="small-h2">
            Where to Conduct Tracers
          </h2>
          <ul>
            <li>
              This tracer activity includes targeted questions and observations for practices in the hospital pharmacy, nursing units (for example, medical/surgical, telemetry, critical care), emergency department, operating rooms, and procedural areas supported by anesthesia providers (for example, interventional radiology, gastroenterology procedures areas, cardiac catheterization procedure areas, ambulatory surgery, obstetrical operating rooms).
            </li>
            <li>
              To thoroughly assess injectable medication practices throughout the hospital, tracers should be conducted on multiple nursing units, operating rooms, and procedural areas to help identify patterns, trends, and variations in practices with injectable medications throughout the organization.
            </li>
          </ul>
          <h2 className="small-h2">
            Time Commitment
          </h2>
          <ul>
            <li>
              Each set of observations and questions asked of clinicians should take approximately 20 to 30 minutes. Interviews can be one-on-one discussions or group conversations.
            </li>
            <li>
              Many injectable medication practices change over time for varying reasons, including medication shortages. Therefore, use this tool periodically to reassess injectable medication processes and the impact of new barriers.
            </li>
          </ul>
          <h2 className="small-h2">
            Disclaimer
          </h2>
          <p>
            Joint Commission Resources’ (JCR) development of this toolkit is sponsored by Fresenius Kabi, is on a non-exclusive basis, and is not an endorsement of that company or its products, or a statement that its expertise or products are superior to those of other companies. JCR and The Joint Commission (TJC), as a matter of policy, do not endorse products. JCR educational programs and publications support, but are separate from, the accreditation activities of TJC. Attendees at JCR education programs and purchasers of JCR publications receive no special consideration or treatment in, or confidential information about, the accreditation process.The inclusion of an organization name, product, or service in a JCR publication should not be construed as an endorsement of such organization product, or service, nor is failure to include an organization name, product, or service to be construed as disapproval. This publication is designed to provide accurate and authoritative information in regard to the subject matter covered. Every attempt has been made to ensure accuracy at the time of publication; however, please note that laws, regulations, and standards are subject to change. Please also note that some of the examples in this publication are specific to the laws and regulations of the locality of the facility. The information and examples in this publication are provided with the understanding that the publisher is not engaged in providing medical, legal, or other professional advice. If any such assistance is desired, the services of a competent professional should be sought.
          </p>
          <h2 className="small-h2">
            Joint Commission Resources Mission
          </h2>
          <p>
            The mission of Joint Commission Resources (JCR) is to continuously improve health care for the public, in collaboration with other stakeholders, by evaluating health care organizations and inspiring them to excel in providing safe and effective care  of the highest quality and value.
          </p>
          <p>
            <strong>© 2018 Joint Commission Resources.</strong> All rights reserved. This tracer tool may not be reproduced in any form or by any means without written permission from JCR. Send requests to make copies of any part of this work to permissions@jcrinc.com.
            <br />
            For more information about JCR, please visit <a href="http://www.jcrinc.com">http://www.jcrinc.com</a>.
          </p>
        </div>
      </div>
    </Fragment>
  );
}

export default AboutPage;



// WEBPACK FOOTER //
// ./src/components/pages/AboutPage.js